import { render } from "./TheGradient.vue?vue&type=template&id=1067dc26&scoped=true&ts=true"
import script from "./TheGradient.vue?vue&type=script&lang=ts"
export * from "./TheGradient.vue?vue&type=script&lang=ts"

import "./TheGradient.vue?vue&type=style&index=0&id=1067dc26&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1067dc26"]])

export default __exports__